import { render } from "./IssueProgressRow.vue?vue&type=template&id=4f2da084&scoped=true"
import script from "./IssueProgressRow.vue?vue&type=script&lang=js"
export * from "./IssueProgressRow.vue?vue&type=script&lang=js"

import "./IssueProgressRow.vue?vue&type=style&index=0&id=4f2da084&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f2da084"

export default script